import React from 'react'
import {findDOMNode} from "react-dom"

import ProjectTypeIcon from "../../../../core/gd-components/icons/project-type-icon"
import NavigationMenuItemProjectMore from "../../../../core/gd-ui/more/project/navigation-project-more-menu"
import MoreProject_PopoverMenu from "../../../../core/gd-ui/more/project/popover-menu";
import ProjectSession from "../../../../core/model2/project/project-session";
import {BUS_APP_LAUNCH} from "../../../../core/gd/app-manager/@event"

type Props = {
    project                 : ProjectSession
    level?                  : number

    isExpanded?             : boolean
    colorized               : boolean

    onMenuItemHandleClick?  : callback
    onAddFolder?            : callback
    style?                  : any

    dndPreview?             : boolean
    dndIsDragged?           : boolean
}

type State = {
    selected    : boolean
    useHint     : boolean
    hovered     : boolean
}

// const debug = "NavigationMenuItemTag"
const debug = false

export default class NavigationMenuItemTag extends React.Component<Props, State> {

    public debouncedCheckHint   : any

    constructor(props: Props) {
        super(props)

        const fragment   = gd.router.history.fragment || ''
        const isSelected = _.startsWith(fragment, 'p/') && fragment.includes(this.props.project.id)

        this.state = {
            selected    : isSelected,
            useHint     : false,
            hovered     : false
        }

        this.debouncedCheckHint = _.debounce(this._checkHintUsage, 300)
    }

    componentDidMount() {
        gd.bus.subscribe(BUS_APP_LAUNCH, this, this.onLaunchApp)

        this.debouncedCheckHint()
    }

    componentDidUpdate() {
        this.debouncedCheckHint()
    }

    componentWillUnmount = () => {
        this.debouncedCheckHint.cancel()

        gd.bus.unsubscribe(this)
    }

    showContextMenu = (e: React.MouseEvent) => {
        const project = gd.session.projects.get(this.props.project.id)!
        if (!project.acl.hasFullAccess) return

        gd.layout.contextMenu.show(e,
            <MoreProject_PopoverMenu project        = {project}
                                     hidePopover    = {() => gd.layout.contextMenu.hide()}/>,
            {
                component: this,
                className   : 'hovered'
            }
        )
    }

    _checkHintUsage = () => {
        const useHint = gd.utils.getTextExceedsNodeWidth(this.props.project.name, findDOMNode(this), 75, 14);

        if (this.state.useHint !== useHint) {
            this.setState({
                useHint: useHint
            })
        }
    }

    onLaunchApp = (data: any) => {

        const project = gd.session.projects.get(this.props.project.id);
        if (!project) return //project may be removed (on launch-app after project delete)

        if (this.state.selected) {
            if (data.params.projectId !== this.props.project.id) {
                this.setState({selected: false})
            }
        } else {
            if (data.params.projectId === this.props.project.id) {
                this.setState({selected: true})
            }
        }
    }

    onClick = (e: React.MouseEvent) => {
        e.stopPropagation()
        gd.goTo("p/"+this.props.project.id)
    }

    render() {
        debug && console.log(debug, 'render', gd.layout.contextMenu.hover, this.props.project)

        if (gd.layout.contextMenu.isShown && gd.layout.contextMenu.hover?.component?.props.project?.id === this.props.project.id) {
            gd.layout.contextMenu.hover.component = this
        }

        const classes = Classes('item project', 'level-'+this.props.level, 'projectId-'+this.props.project.id /*required for scroll to node*/, {
            'selected'          : this.state.selected,
            'dnd-preview'       : this.props.dndPreview,
            'dnd-is-dragged'    : this.props.dndIsDragged,
            'hovered'           : this.state.hovered || gd.layout.contextMenu.hover?.component?.props.project?.id === this.props.project.id
        })

        const noAccess = !this.props.project.access

        return (
            <div className={classes} style={this.props.style} onClick={this.onClick} onContextMenu={this.showContextMenu}>
                <div className="row p-l-20">
                    <ProjectTypeIcon className  = "icon"
                                     projectId  = {this.props.project.id}
                                     colorize   = {this.props.colorized}
                                     isExpanded = {this.props.isExpanded}/>
                    <div className="name">{this.props.project.name}</div>

                    {!noAccess &&
                        <NavigationMenuItemProjectMore projectId   = {this.props.project.id}
                                                       parent      = {this}
                                                       showPinStar = {true}/>}
                </div>
            </div>
        )
    }
}
